import { Flexoffers } from '../../utils/types'

export type ReactTextProps = {
  text: string
  tokenProperties?: string
  cqStyleIds?: string
  isInEditor?: boolean
  className?: string
  flexOffers?: Flexoffers
  index?: number
  id?: string
  isParsed?: boolean
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  jsonUrl?: string
}

export enum ReactTextDesignTokens {
  EYEBROW1 = 'cox-text-eyebrow1',
  EYEBROW2 = 'cox-text-eyebrow2',
  EYEBROW3 = 'cox-text-eyebrow3',
  INTERACTIVE1 = 'cox-text-interactive1',
  INTERACTIVE2 = 'cox-text-interactive2',
  INTERACTIVE3 = 'cox-text-interactive3'
}
